import config          from '../../etc/config.json';
import apiFactory      from '../api';

export default apiFactory({
    apiUrl         : config.adminApiUrl,
    apiPrefix      : config.adminApiPrefix
    // adminApiUrl    : config.adminApiUrl,
    // adminApiPrefix : config.adminApiPrefix
});
